"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalUserSync = exports.USYNC_STORAGE_PREFIX = void 0;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var activities_1 = require("../modules/consent/activities");
var ConsentHandler_1 = require("./consent/ConsentHandler");
var Storage_1 = __importDefault(require("./Storage"));
var moduleTypes_1 = require("../modules/consent/moduleTypes");
var User_1 = require("./User");
var __1 = require("..");
var utils_1 = require("../utils/utils");
var log_1 = require("../utils/log");
exports.USYNC_STORAGE_PREFIX = '__bc_usync_';
var UserSync = /** @class */ (function () {
    function UserSync() {
        this._pending = [];
        this._timeout = 2000;
        this._timeout_handle = null;
        this.ready = false;
        this.callback = function () { };
        this.BIDDER_SYNC_CONFIGS = {
            freewheel: {
                type: "image",
                url: "https://ads.stickyadstv.com/user-matching?id={{id}}&_fw_gdpr={{gdpr_applies}}&_fw_gdpr_consent={{gdpr_string}}&bc_userId={{bc_userId}}",
                replaceMacros: function (url, ext) {
                    if (url === void 0) { url = ""; }
                    // get gdpr applies
                    var gdpr_applies = ConsentHandler_1.gdprConsentHandler.getGdprApplies();
                    // get gdpr string
                    var gdpr_string = ConsentHandler_1.gdprConsentHandler.getGdprString();
                    // replace macros
                    return url.replace('{{id}}', ext.sync_id)
                        .replace('{{gdpr_applies}}', gdpr_applies ? '1' : '0')
                        .replace('{{gdpr_string}}', gdpr_string)
                        .replace('{{bc_userId}}', User_1.globalUser.getUUID());
                },
                extraSyncing: function (ext) {
                    var url = "https://ads.stickyadstv.com/auto-user-sync?pxId={{pxId}}".replace('{{pxId}}', ext.sync_id);
                    // create new image with url as source
                    var img = new Image();
                    // set source
                    img.src = url;
                }
            },
            magnite: {
                type: "image",
                url: "https://pixel.rubiconproject.com/exchange/sync.php?p={{partner_key}}&gdpr={{gdpr_applies}}&gdpr_consent={{gdpr_string}}&us_privacy={{usp_string}}",
                replaceMacros: function (url, ext) {
                    if (url === void 0) { url = ""; }
                    // get gdpr applies
                    var gdpr_applies = ConsentHandler_1.gdprConsentHandler.getGdprApplies();
                    // get gdpr string
                    var gdpr_string = ConsentHandler_1.gdprConsentHandler.getGdprString();
                    // get usp string
                    var usp_string = ConsentHandler_1.uspConsentHandler.getUsPrivacy();
                    // replace macros
                    return url.replace('{{partner_key}}', ext.partner_key)
                        .replace('{{gdpr_applies}}', gdpr_applies ? '1' : '0')
                        .replace('{{gdpr_string}}', gdpr_string)
                        .replace('{{usp_string}}', usp_string);
                }
            },
            ix: {
                type: "iframe",
                url: "https://ssum-sec.casalemedia.com/usermatch?s={{site_id}}&cb={{callback}}",
                replaceMacros: function (url, ext) {
                    if (url === void 0) { url = ""; }
                    var redirect = encodeURIComponent("https://usync.bigcrunch.com/s2s/userSync?bc_userId=".concat(User_1.globalUser.getUUID(), "&bidder=ix&userid="));
                    return url.replace('{{site_id}}', ext.site_id)
                        .replace('{{callback}}', redirect);
                }
            },
            nexxen: {
                type: "image",
                url: "https://sync.1rx.io/usersync2/rmpssp?sub={{sub}}",
                replaceMacros: function (url, ext) {
                    if (url === void 0) { url = ""; }
                    return url.replace('{{sub}}', ext.sub);
                }
            },
            pubmatic: {
                type: "image",
                url: "https://image8.pubmatic.com/AdServer/ImgSync?p={{publisher_id}}&gdpr={{gdpr_applies}}&gdpr_consent={{gdpr_string}}&pu={{pu}}",
                replaceMacros: function (url, ext) {
                    if (url === void 0) { url = ""; }
                    // get gdpr applies
                    var gdpr_applies = ConsentHandler_1.gdprConsentHandler.getGdprApplies();
                    // get gdpr string
                    var gdpr_string = ConsentHandler_1.gdprConsentHandler.getGdprString();
                    // redirect url
                    var redirect = encodeURIComponent("https://usync.bigcrunch.com/s2s/userSync?bc_userId=".concat(User_1.globalUser.getUUID(), "&bidder=pubmatic&userid=#PMUID"));
                    var pu = encodeURIComponent("https://image4.pubmatic.com/AdServer/SPug?p=".concat(ext.publisher_id, "&mpc=4&fp=1&pmc=PM_PMC&pr=").concat(redirect));
                    // replace macros
                    return url.replace('{{publisher_id}}', ext.publisher_id)
                        .replace('{{gdpr_applies}}', gdpr_applies ? '1' : '0')
                        .replace('{{gdpr_string}}', gdpr_string)
                        .replace('{{pu}}', pu);
                }
            }
        };
    }
    /**
     *
     * @param bidder_name
     * @returns {string|null}
     * @description Get user id from storage
     */
    UserSync.prototype.getUserIdFromStorage = function (bidder_name) {
        var storageObj = { 'componentType': moduleTypes_1.MODULE_TYPE_UID, 'componentName': bidder_name };
        // get cookie name
        var storage_name = exports.USYNC_STORAGE_PREFIX + bidder_name;
        // get cookie value
        var value = Storage_1.default.getItemFromStorage(storage_name, storageObj);
        // check if cookie value exists
        if (value) {
            return this.setUserIdInStorage(storage_name, value, storageObj);
        }
        // return null
        return null;
    };
    UserSync.prototype.setUserIdInStorage = function (storage_name, value, storageObj) {
        Storage_1.default.setItemInStorage(storage_name, value, storageObj);
        // return cookie value
        return value;
    };
    UserSync.prototype.checkIfReady = function () {
        if (this._pending.length === 0 || this.ready === true) {
            (0, log_1.logInfo)('User sync is ready');
            this.ready = true;
            this.callback();
            this.callback = function () { };
        }
    };
    /**
     *
     * @returns {boolean}
     * @description Sync users with bidders
     */
    UserSync.prototype.syncUsers = function (userSyncs, bidders) {
        return __awaiter(this, void 0, void 0, function () {
            var ua, browser, _loop_1, this_1, bidder_name;
            var _this = this;
            return __generator(this, function (_a) {
                ua = new ua_parser_js_1.default((0, utils_1.getUserAgent)());
                browser = ua.getBrowser().name || '';
                if (__1.globalSettings.property_id == '34a5ddec-697b-424e-81d2-e6bb46a1b83e' ||
                    browser.includes('Brave') ||
                    browser.includes('Safari') ||
                    browser.includes('Firefox') ||
                    (!Storage_1.default.checkCookieSupport() &&
                        !Storage_1.default.hasLocalStorage())) {
                    this.checkIfReady();
                    return [2 /*return*/, true];
                }
                // set a timeout
                if (!this._timeout_handle) {
                    this._timeout_handle = setTimeout(function () {
                        (0, log_1.logInfo)('User sync timeout');
                        clearTimeout(_this._timeout_handle);
                        _this._timeout_handle = null;
                        _this.ready = true;
                        _this.checkIfReady();
                    }, this._timeout);
                }
                // check if activity is allowed
                if (!ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_SYNC_USER, { gvlid: {} })) {
                    (0, log_1.logInfo)('User sync not allowed by consent');
                    this.ready = true;
                    this.checkIfReady();
                    return [2 /*return*/, true];
                }
                _loop_1 = function (bidder_name) {
                    // check if user id exists in storage
                    if (!this_1.getUserIdFromStorage(bidder_name)) {
                        // get bidder config
                        var bidder_config = bidders[bidder_name] || {};
                        // get user sync config
                        var usync_config = userSyncs[bidder_name] || {};
                        // check if bidder is enabled
                        if (bidder_config.enabled === false)
                            return "continue";
                        // get bidder sync config
                        var bidder_sync_config = this_1.BIDDER_SYNC_CONFIGS[bidder_name];
                        // check if bidder sync config exists
                        if (!bidder_sync_config)
                            return "continue";
                        // check if bidder sync is allowed
                        if (!ConsentHandler_1.allConsentHandler.isActivityAllowed(activities_1.ACTIVITY_SYNC_USER, { 'componentType': moduleTypes_1.MODULE_TYPE_UID, 'componentName': bidder_name }))
                            return "continue";
                        // get sync url
                        var url = bidder_sync_config.url;
                        // check if replace macro function exists
                        if (typeof bidder_sync_config.replaceMacros === 'function') {
                            // replace macros
                            url = bidder_sync_config.replaceMacros(url, usync_config);
                        }
                        // add bidder to pending
                        this_1._pending.push(bidder_name);
                        if (bidder_sync_config.type == "fetch") {
                            // fetch data
                            this_1.fetchData(url);
                        }
                        else if (bidder_sync_config.type == "image") {
                            // trigger pixel
                            (0, utils_1.triggerPixel)(url, function () {
                                // check if bidder exists
                                if (bidder_name) {
                                    // remove bidder from pending
                                    _this._pending = _this._pending.filter(function (bidder) { return bidder !== bidder_name; });
                                }
                                _this.checkIfReady;
                            }, 1000);
                        }
                        else if (bidder_sync_config.type == "iframe") {
                            (0, utils_1.insertUserSyncIframe)(url, function () {
                                // check if bidder exists
                                if (bidder_name) {
                                    // remove bidder from pending
                                    _this._pending = _this._pending.filter(function (bidder) { return bidder !== bidder_name; });
                                }
                                _this.checkIfReady;
                            }, 1000);
                        }
                        // check if extra syncing function exists
                        if (typeof bidder_sync_config.extraSyncing === 'function') {
                            bidder_sync_config.extraSyncing(usync_config);
                        }
                    }
                    this_1.checkIfReady();
                };
                this_1 = this;
                // loop through bidders
                for (bidder_name in bidders) {
                    _loop_1(bidder_name);
                }
                return [2 /*return*/, true];
            });
        });
    };
    /**
     *
     * @param url
     * @description Fetch data
     */
    UserSync.prototype.fetchData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, (0, utils_1.fetchWithTimeout)(url, 1000, { credentials: 'include' })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error('Error Syncing User');
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data_1 = (_a.sent()) || {};
                        // check if bidder exists
                        if (data_1.bidder) {
                            // set user id in storage
                            if (data_1.external_id) {
                                this.setUserIdInStorage(exports.USYNC_STORAGE_PREFIX + data_1.bidder, data_1.external_id, { 'componentType': moduleTypes_1.MODULE_TYPE_UID, 'componentName': data_1.bidder });
                            }
                            if (__1.globalSettings.user_syncs[data_1.bidder]) {
                                __1.globalSettings.user_syncs[data_1.bidder].buyeruid = data_1.external_id;
                            }
                            // remove bidder from pending
                            this._pending = this._pending.filter(function (bidder_name) { return bidder_name !== data_1.bidder; });
                        }
                        this.checkIfReady();
                        console.log('Data received:', data_1);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error:', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return UserSync;
}());
exports.globalUserSync = new UserSync();
